<template>
	<div class="topbar">
		<router-link class="logo" to="/">
			<img src="img/mis-logo-marketcase.svg">
		</router-link>

		<div v-if="!!user" :class="['user-profile font-small', isIE ? 'is-ie' : '']">

			<!--<svg class="dashboard-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.03 512.03">
				<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_1-2" data-name="Layer 1">
					<defs>
						<linearGradient id="gg" x1="20%" y1="0%" x2="30%" y2="100%">
							<stop offset="20%" />
							<stop offset="100%" />
						</linearGradient>
					</defs>
				<path d="M42.29,397q-1.45-2.21-2.87-4.44Q40.83,394.78,42.29,397Z"/>
				<path d="M39.06,392c-.93-1.48-1.84-3-2.74-4.46C37.22,389,38.13,390.49,39.06,392Z"/>
				<path d="M36,386.92q-1.35-2.25-2.65-4.54Q34.63,384.68,36,386.92Z"/>
				<path d="M30.42,377.14c.5.93,1,1.84,1.53,2.76,6.1-8.29,37.28-61.53,77.57-132.37,25.3-44.5,31.8-54.6,41.8-65.2,12.6-13.2,19.9-16.3,39.3-16.3,15,0,22,1.9,31.9,8.7,8.1,5.6,15,15,18.7,25.3l2.3,6.5L244,294c.5,85.9.5,87.4,2.4,84.6,8.2-12.5,38.6-64.6,72.3-123.6,28.4-49.8,30.9-53.9,39.4-65.1,7.5-9.8,14.5-16.1,22.7-20.1,6.3-3.1,7.2-3.3,20.3-3.6,16.3-.5,23.5,1.2,33.6,7.7s19,19.7,21.3,32c.6,3.4,1,42,1,106.9,0,58.14,0,87.94.44,101.21A254.89,254.89,0,0,0,512,256C512,114.62,397.41,0,256,0S0,114.62,0,256A254.88,254.88,0,0,0,30.42,377.14Z"/><path d="M45.65,401.93c-1-1.48-2-3-3-4.47C43.6,399,44.62,400.45,45.65,401.93Z"/><path d="M33.07,381.93c-.38-.67-.75-1.35-1.12-2h0Z"/>
				<path d="M49.11,406.79c-1.09-1.49-2.17-3-3.22-4.51C46.94,403.8,48,405.3,49.11,406.79Z"/>
				<path d="M424.82,329.23l-.3-119.7-2.3-4.3c-3.8-7.1-12.3-10.9-21.6-9.7-9.8,1.3-8.7-.4-86.6,132.9L243.62,449H211V330c0-105.2-.2-119.5-1.5-122.8a20.07,20.07,0,0,0-8.6-9.7c-3.5-1.8-11.6-2.6-15.9-1.5-7.5,1.8-10.7,6.7-72.2,112.2-30.27,51.83-56.59,97.24-60,103.48,1,1.32,2,2.62,3.07,3.91l.45.57A256,256,0,0,0,425,448.33Z"/><path d="M52.79,411.72h0l0-.07Z"/>
				<path d="M56.31,416.19l-.45-.57-.16-.18Z"/>
				<path d="M49.26,407c1.12,1.53,2.25,3,3.4,4.55C51.51,410,50.38,408.53,49.26,407Z"/>
				</g></g>
			</svg>-->			
			<a target="_blank" href="https://www.mis-implants.com">MIS Website</a>
			<button class="sign-out" id="signout" @click="signout">Sign Out</button>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			showdrop: false
		}
	},
	methods: {
		...mapActions([
			'userSignout'
		]),
		signout() {
			this.$set(this, 'showdrop', false);
			this.userSignout();
		},
		changeMode()
		{

		}
	},
	computed: {
		...mapState([
			'user'
		]),
		...mapGetters([
			'isIE'
		])
	}
}
</script>
<style lang="stylus">
@import '~rupture'
@import '~settings'

.gradient1
	background linear-gradient(to bottom, #fff, #c8c7c7)
	-webkit-background-clip text
	-webkit-text-fill-color transparent
.inmid
	display inline-block
	vertical-align middle
	line-height 1
.topbar
	min-width 768px
	position fixed
	top 0
	height 70px
	--background url('./assets/texture.jpg') repeat-x 0 0
	width 100%
	padding 0px 55px
	--border solid 2px red
	z-index 11
	+below(815px)
		padding 0 0 0 20px
		min-width initial
	.arw
		margin-left 10px
	.user-profile
		//font-size 13px
		+below(815px)
			display none
		position absolute
		top 0
		right 245px
		height 100%
		display flex
		align-items center
		justify-content flex-end
		min-width 300px
		&.is-ie
			padding-right 1vw
		& > *
			flex 0 0 22%
			white-space nowrap
			//margin-right 15px
			margin-left 15px
		a
			display inline-block
			vertical-align middle
			opacity 0.7
			color #545454
			transition color 0.3s ease-out, opacity 0.3s ease-out
			.dashboard-icon
				height 22px
				width @height
				display inline-block
				vertical-align middle
				margin-right 5px
				#gg
					stop
						transition stop-color 0.3s ease-out
					stop:first-child
						stop-color rgba(#fdfdfd, 0.9)
					stop:last-child
						stop-color rgba(#a8a6a6, 0.9)
				path
					backface-visibility hidden
					fill url(#gg)
			&:hover
				opacity 1
				color #545454
				#gg
					stop:first-child
						stop-color rgba(#da9644, 0.9)
					stop:last-child
						stop-color rgba(#f9df72, 0.9)

		.sign-out
			display inline-block
			vertical-align middle
			color #545454
			opacity 0.7
			transition opacity 0.3s ease-out
			&:hover
				opacity 1
			&:before
				content ''
				background url('./assets/signout.svg') no-repeat 0 50%
				display none 
				////inline-block
				width 24px
				height 20px
				margin-right 10px
				vertical-align middle
		// .inner
		// 	cursor pointer
		// 	position relative
		// 	z-index 10
		// 	height 100%
		// 	&:before
		// 		content ''
		// 		height 100%
		// 		display inline-block
		// 		vertical-align middle
		// 	& > *
		// 		vertical-align middle
		// 	.user-name
		// 		display inline-block
		// 		text-transform uppercase
		// 		padding-left 10px
		// 		color #939393
		// 		+tablet()
		// 			position relative
		// 			transform translateY(4px)

		// 	.user-flag
		// 		display inline-block
		// 		position relative
		// 		width 32px
		// 		height 32px
		// 		border-radius unit(@width/2, 'px')
		// 		overflow hidden
		// 		text-align center
		// 		img
		// 			self-center()
		// 			width 175%
		// 			height @width
		// .user-drop
		// 	position absolute
		// 	height 0
		// 	top 49px
		// 	right 0
		// 	background #fff
		// 	transition all 300ms weeeha
		// 	opacity 0
		// 	transform translate(0, -10%)
		// 	z-index 9
		// 	overflow hidden
		// 	/.app-results &
		// 		background #7a7a7a
		// 	&.active
		// 		opacity 1
		// 		transform translate(0, 0)
		// 		height 48px

	.logo
		img
			height 100%
			width 17vw
			min-width 250px
			max-width 340px
		color #fff
		float left
			//background url('./assets/logo-marketcase.svg') no-repeat 0 50%
		i
			@extend .inmid
			@extend .gradient1
			font-size 23px
		span
			@extend .inmid
			@extend .gradient1
			height 22px
			border-left 1px solid #fff
			font normal 24px/1 arial, sans-serif
			padding-left 7px
			margin-left 3px
	.shapeChangeImg
		height clamp(14px,1vw,16px)
		width auto
		flex 0
		opacity 0.7
		position relative
		top -1px
		right 10px

</style>
